import { render, staticRenderFns } from "./BatchIssuesPanel.vue?vue&type=template&id=fb126972"
import script from "./BatchIssuesPanel.vue?vue&type=script&lang=js"
export * from "./BatchIssuesPanel.vue?vue&type=script&lang=js"
import style0 from "./BatchIssuesPanel.vue?vue&type=style&index=0&id=fb126972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports